import { logout } from "src/helpers/authenticationBridge";
import { useAuthenticatedUser } from "src/contexts/AuthenticatedUserContext";
import React, { FC, useState } from "react";
import {
    FontAwesomeIcon,
    FontAwesomeIcons,
} from "src/constants/fontAwesomeIcons";
import OutsideClick from "../OutsideClick/OutsideClick";

import "./NavProfileButton.scss";

const NavProfileButton: FC = () => {
    //
    // -- States --
    const [isOpen, setIsOpen] = useState<boolean>(false);

    //
    // -- Hooks --
    const { user } = useAuthenticatedUser();

    const handleClickOutside = (_event: MouseEvent) => {
        setIsOpen(false);
    };

    const handleOnClickEvent: React.MouseEventHandler<HTMLButtonElement> = (
        event
    ) => {
        rippleEffect(event);
        setIsOpen(!isOpen);
    };

    const rippleEffect = (
        event: React.MouseEvent<HTMLButtonElement, MouseEvent>
    ) => {
        let ripple = document.createElement("span");

        // Add ripple class to span
        ripple.classList.add("ripple");

        // Add span to the button
        event.currentTarget.appendChild(ripple);

        // Remove span after 0.3s
        setTimeout(() => {
            ripple.remove();
        }, 300);
    };

    return (
        <OutsideClick onOutsideClick={handleClickOutside}>
            <div className="dropdown">
                <button
                    id="dropdownButton"
                    className="nav-button-profile nav-button-profile-transition"
                    aria-label={user ? `${user.fullName} profile menu` : "User profile menu"}
                    aria-haspopup="menu"
                    aria-expanded={isOpen}
                    onClick={handleOnClickEvent}
                    type="button"
                >
                    <FontAwesomeIcon
                        icon={
                            user
                                ? FontAwesomeIcons.Duotone.CIRCLEUSER
                                : FontAwesomeIcons.Regular.USER
                        }
                        fixedWidth
                    />
                </button>
                {isOpen && (
                    <div id="myDropdown" className="dropdown-content show">
                        {user ? (
                            <ul>
                                <li>
                                    <span className="nav-button-profile-text">
                                        {user.fullName}
                                    </span>
                                </li>
                                <li
                                    onClick={logout}
                                >
                                    <span className="nav-button-profile-text">
                                        Logout
                                    </span>
                                </li>
                            </ul>
                        ) : null}
                    </div>
                )}
            </div>
        </OutsideClick>
    );
};

export default NavProfileButton;
